import { useTranslation } from 'react-i18next';

// #96 (Task 9): aus scope-table.tsx extrahiert — die Anzeige-Hälfte des ruhigen,
// zeilennahen "gespeichert"-Feedbacks (Logik siehe use-saved-flash.ts). `aria-live="polite"`,
// damit der Hinweis auch per Screenreader ankommt, ohne dass ein globaler Toast dafür nötig wäre.
// Review Task 11: die `aria-live`-Region muss DAUERHAFT gemountet sein — Region und Inhalt im
// selben Commit einzublenden, kündigen Screenreader (NVDA/JAWS/VO) nicht an, weil sie nur
// Mutationen INNERHALB einer bereits vorhandenen Live-Region beobachten. Muster wie
// toast-viewport.tsx: die Region bleibt stehen, nur der Inhalt wechselt zwischen leer und Text.
export function SavedHint({ visible, className }: { visible: boolean; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      aria-live="polite"
      className={visible ? `text-[11px] text-status-pass ${className ?? ''}` : undefined}
    >
      {visible ? `✓ ${t('feedback.savedInline')}` : ''}
    </span>
  );
}
